import React from "react";
import SideShape from "../../assets/images/login_shape_gray.svg";
import { CONSTANTS } from "../../constants/Constants";
import Input from "../Inputs";
import Button from "../Buttons";
import LoadSpinner from "../LoadingSpinner";
import OTPScreen from "../OtpScreen";


interface AuthProps {
  isLoginScreen: boolean;
  email: string;
  companyName?: string;
  showOTPScreen: boolean;
  authError: string;
  isDisable: boolean;
  isLoading: boolean;
  changeHandler: (e: Event) => void;
  otpRequest: (e: React.FormEvent) => void;
  otpChangeHandler: (otp: string) => void;
  verifyOTPAndLogin: () => void;
}
const AuthScreen = ({
  isLoginScreen = true,
  showOTPScreen = false,
  email = "",
  companyName = "",
  authError = "",
  isDisable = false,
  isLoading = false,
  changeHandler = () => {},
  otpRequest = () => {},
  otpChangeHandler = () => {},
  verifyOTPAndLogin = () => {},
}: AuthProps) => {
  return (
    <div className="min-h-[calc(100vh-80px)] bg-white md:w-3/5 mx-auto">
      <div className="max-w-[1400px] mx-auto px-3 md:px-6 h-ful">
        {!showOTPScreen ? (
          <div className="flex flex-col-reverse md:flex-row items-center justify-between h-full pt-16 md:pt-24 gap-20">
            {/* Left Side - Form */}
            <div className="w-full max-w-[460px] pt-10 lg:pt-0">
              <div className="mb-8">
                <h1 className="text-[34px] font-semibold text-[#1A1A1A] leading-tight mb-2">
                  {CONSTANTS.WELCOME_DIYA_TEXT}
                </h1>
                <p className="text-[15px] text-[#232323]">
                  {CONSTANTS.SIGN_UP_EFFORTLESSLY_TXT}
                </p>
              </div>

              <div className="w-full">
                <div className="mb-4">
                {!isLoginScreen && (
                    <Input
                      input_name={
                        CONSTANTS.PAYLOAD_KEYS.USER_SIGN_UP_KEYS.COMPANY_NAME
                      }
                      other_classes="mb-4"
                      value={companyName}
                      type="text"
                      change_handler={changeHandler}
                      placeholder={CONSTANTS.ENTER_COMPANY_NAME_TXT}
                    />
                  )}
                  <Input
                    input_name={CONSTANTS.PAYLOAD_KEYS.USER_SIGN_UP_KEYS.EMAIL}
                    value={email}
                    type="email"
                    change_handler={changeHandler}
                    placeholder={CONSTANTS.ENTER_EMAIL_TXT}
                  />
                  <small className="text-error">{authError}</small>
                </div>
                <div className="relative">
                  <Button
                    on_click_handler={otpRequest}
                    is_disable={isDisable}
                    btn_label={CONSTANTS.REQUEST_OTP_TXT}
                    type={"primary"}
                  />
                  {isLoading && (
                    <LoadSpinner classes={"absolute top-0 left-0"} />
                  )}
                </div>
              </div>
            </div>

            {/* Right Side - Shape */}
            <div className="image-div lg:flex hidden w-full max-w-[460px] md:w-[560px] md:h-[500px] items-center justify-center pb-8 md:pb-0">
              <img
                src={SideShape}
                alt="Decorative Shape"
                className="object-contain"
              />
            </div>
          </div>
        ) : (
          <OTPScreen
            length={6}
            on_change={otpChangeHandler}
            on_click={verifyOTPAndLogin}
            otp_error={authError}
            isLoading={isLoading}
            resendOTP={otpRequest}
          />
        )}

        <div className="flex items-center justify-center mt-32 md:mt-0 md:justify-start h-[100px] text-[#656565] text-sm md:text-base">
          <p>
            {CONSTANTS.NO_ACCOUNT_QUES_TXT}{" "}
            <span className="text-primary-light">{CONSTANTS.SALES_DIYA_TXT}</span>
            <br />
            {CONSTANTS.COPY_RIGHT_TXT}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthScreen;
